<template>
  <div class="moviesApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="header">
      <div class="search">
        <div class="Location" @click="$router.push('citys')">
          <i class="el-icon-location-information"></i>
          <span>{{cityData.cityName}}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="inpTxt">
          <i class="el-icon-search"></i>
          <input type="text" v-model="keywords" :placeholder="'搜索'+placeholderTxt+'名称'">
          <button @click="getSearch">搜索</button>
        </div>
      </div>
      <div style="height:45px">
        <div class="tab">
          <div @click="clickTab(0)" :class="types == 0 ? 'item on' : 'item'">正在热映</div>
          <div @click="clickTab(2)" :class="types == 2 ? 'item on' : 'item'">附近影院</div>
          <div @click="clickTab(1)" :class="types == 1 ? 'item on' : 'item'">即将上映</div>
        </div>
      </div>
    </div>
    <div style="height:95px;"></div>
    <ul v-if="types != 2">
      <li v-for="(item,i) in setMovies.list">
        <el-image @click="$router.push('moviesdetail?id='+item.movieId)" style="width: 100px; height: 120px" :src="item.pic" fit="cover"></el-image>
        <div class="right" @click="$router.push('moviesdetail?id='+item.movieId)">
          <h2>{{item.name}}<span>{{item.versionTypes}}</span></h2>
          <p v-if="timestamp - item.publishDate > 0">评分<font>{{item.grade}}</font></p>
          <p v-if="timestamp - item.publishDate <= 0">暂无评分</p>
          <p>{{timestamp - item.publishDate > 0 ? item.filmTypes : getLocalTime(item.publishDate)+' 上映'}}</p>
          <p class="last">主演：{{item.cast}}</p>
        </div>
        <a @click="gpush(item.movieId)" :style="timestamp - item.publishDate <= 0 ? 'background: linear-gradient(90deg, #3F9DEC, #53C6F1);' : ''">{{timestamp - item.publishDate > 0 ? '购票' : '预售'}}</a>
      </li>
    </ul>
    <dl v-if="types == 2">
      <dd v-for="(item,i) in setCinema.list" @click="$router.push('cinema?id='+item.cinemaId+'&distance='+item.distanceText)">
        <h2>{{item.cinemaName}}</h2>
        <p>{{item.cinemaAddress}}</p>
        <p><i class="el-icon-location-information"></i>{{item.distanceText}}</p>
        <p class="last">￥<font>{{item.downPrice}}</font>起</p>
      </dd>
    </dl>
    <div class="moreAll" @click="getMoreAll" v-if="setMovies.total >= (page+1)*15 && types != 2">查看更多<i class="el-icon-arrow-right"></i></div>

    <div class="moreAll" @click="getMoreAll1" v-if="setCinema.total >= (pageCinema+1)*50 && types == 2">查看更多<i class="el-icon-arrow-right"></i></div>
  </div>
  
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        setMovies:[],
        types:0,
        timestamp:0,
        setCinema:[],
        cityData:[],
        page:0,
        pageCinema:0,
        placeholderTxt:'电影',
        keywords:'',
        latitude:'',
        longitude:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('user') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/movies');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }
      
    },
    mounted() {
      this.timestamp = Date.parse(new Date());
      if(localStorage.getItem('user') == null){
        this.login();
      }else{
        if(localStorage.getItem('cCode') == null){
          this.getQquey();
        }else{
          var cCode = JSON.parse(localStorage.getItem('cCode'));
          if(cCode.expires <= Date.parse(new Date())){
            localStorage.removeItem('cCode');
            localStorage.removeItem('latLong');
            this.getQquey();
          }else{
            this.cityData = cCode;
            this.getMovies();
          }
          
        }
      }
      this.beforeMount();
      
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getLocalTime:function(nS) {
        var str = new Date(parseInt(nS)).toLocaleString();
        return str.substr(0, str.length - 8)    
      },
      clickTab:function(inx){
        this.types = inx;
        this.keywords = '';
        if(inx != 2){
          this.page = 0;
          this.placeholderTxt = '电影';
          this.getMovies();
        }else{
          this.pageCinema = 0;
          this.placeholderTxt = '影院';
          this.getCinema();
        }
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        document.documentElement.scrollTop = document.body.scrollTop = -200; 
      },
      gpush:function(id){
        window.location.href="http://user.4008005216.com/main/cinemalist?id="+id
      },
      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        that.fullscreenLoading = true;
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'getLocation',
              'openLocation'
            ]
          });
          wx.ready(function() {
            wx.getLocation({
              type: 'wgs84',
              success: function (res) {
                that.latitude = res.latitude;
                that.longitude = res.longitude;
                $.ajax({
                  type:'post',
                  url:that.$host+'home/movies/getAddressInfo',
                  data:{
                    latitude:res.latitude,
                    longitude:res.longitude,
                  },
                  dataType:'json',
                  success:function(data){
                    var expires = Date.parse(new Date()) / 1000;
                    expires = (expires + 300) * 1000;
                    var data = {
                      cityCode:data.data.city_code,
                      cityName:data.data.city,
                      expires:expires
                    };
                    localStorage.setItem('cCode', JSON.stringify(data));
                    var latlong = {
                      latitude:res.latitude,
                      longitude:res.longitude,
                    };
                    localStorage.setItem('latLong', JSON.stringify(latlong));
                    that.cityData = data;
                    that.getMovies();
                  }
                })
              }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      getSearch:function(){
        if(this.types != 2){
          this.page = 0;
          this.getMovies();
        }else{
          this.pageCinema = 0;
          this.getCinema();
        }
      },
      getMoreAll:function(){
        this.page = this.page + 1
        this.getMovies();
      },
      getMovies:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/index',
          data:{
            types:that.types,
            cityCode:that.cityData.cityCode,
            page:that.page,
            keywords:that.keywords
          },
          dataType:'json',
          success:function(data){
            if(that.page == 0){
              that.setMovies = data.data;
            }else{
              that.setMovies.list = that.setMovies.list.concat(data.data.list)
            }
            that.fullscreenLoading = false;
          }
        })
      },
      getMoreAll1:function(){
        this.pageCinema = this.pageCinema + 1
        this.getCinema();
      },
      getCinema:function(){
        var that = this;
        that.fullscreenLoading = true;
        var lat = JSON.parse(localStorage.getItem('latLong'))
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/cinema',
          data:{
            cityCode:that.cityData.cityCode,
            page:that.pageCinema,
            keywords:that.keywords,
            latitude:lat.latitude,
            longitude:lat.longitude
          },
          dataType:'json',
          success:function(data){
            if(that.pageCinema == 0){
              that.setCinema = data.data;
            }else{
              that.setCinema.list = that.setCinema.list.concat(data.data.list)
            }
            that.fullscreenLoading = false;
          }
        })
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('user', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .moviesApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .moviesApp .header{
    position: fixed;
    top:0;
    left:0;
    width:100%;
    z-index:99;
    height:85px;
    background:#ececec;
  }
  .moviesApp .header .search{
    height:40px;
  }
  .moviesApp .header .search .inpTxt{
    float:left;
    height:40px;
    width:75%;
    position:relative;
  }
  .moviesApp .header .search .inpTxt i{
    position:absolute;
    top:50%;
    left:15px;
    font-size:18px;
    transform: translateY(-50%);
    margin-top:3px;
    color:#666
  }

  .moviesApp .header .search .inpTxt button{
    position:absolute;
    top:50%;
    right:15px;
    font-size:18px;
    transform: translateY(-50%);
    margin-top:3px;
    color:#fff;
    background:#3F9DEC;
    border:0;
    height:35px;
    border-radius:0 40px 40px 0;
    padding:0 13px;
    font-size:16px;
  }
  .moviesApp .header .search input{
    border:none;
    outline:none;
    border-radius:40px;
    font-size:16px;
    padding:0 10px 0 40px;
    margin-top:5px;
    width:80%;
    height:35px;
  }
  .moviesApp .header .Location{
    float:left;
    line-height:45px;
    margin-left:3%;
    width:20%
  }
  .moviesApp .header .Location span{
    float:left;
    width:50%;
    font-size:13px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color:#666;
    margin-left:3px
  }
  .moviesApp .header .Location i{
    font-size:13px;
    color:#666;
    float:left;
    line-height:45px;
  }
  .moviesApp .header .tab{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    height:45px;
    background:#ececec;
    width:100%;
  }
  .moviesApp .tab .item{
    width:33.3%;
    height:45px;
    line-height:45px;
    font-size:16px;
    color:#666;
    text-align:center;
  }
  .moviesApp .tab .on{
    position:relative;
    color:#000;
    font-weight:bold;
  }
  .moviesApp .tab .on:after{
    position:absolute;
    content:'';
    bottom:6px;
    background: linear-gradient(-90deg, #FE506A, #FE5CA3);
    width:25px;
    height:4px;
    left:50%;
    transform: translateX(-50%);
    border-radius: 5px;
  }
  .moviesApp ul{
    width:94%;
    margin:0 auto;
    padding-bottom:10px
  }
  .moviesApp ul li{
    background:#fff;
    border-radius: 6px;
    margin-bottom:10px;
    padding:10px;
    position:relative;
  }
  .moviesApp ul li a{
    position:absolute;
    background: linear-gradient(90deg, #FE506A, #FE5CA3);
    top:45%;
    transform: translateY(-50%);
    color:#fff;
    font-size:14px;
    width:60px;
    right:4%;
    height:30px;
    border-radius: 30px;
    text-align:center;
    line-height:30px;
  }
  .moviesApp ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;  
  }
  .moviesApp ul li .el-image{
    float:left;
    width:100px;
  }
  .moviesApp ul li .el-image img{
    border-radius: 8px;
  }
  .moviesApp ul li .right{
    float:left;
    width:calc(100% - 108px);
    height:120px;
    margin-left:8px
  }
  .moviesApp ul li .right h2{
    font-size:16px;
    font-weight:bold
  }
  .moviesApp ul li .right h2 span{
    font-weight:400;
    font-size:11px;
    color:#999;
    border:solid 1px #999;
    margin-left:8px;
    padding:1px 5px;
    border-radius: 4px;
    position:relative;
    top:-2px
  }
  .moviesApp ul li .right p{
    font-size:14px;
    color:#666;
    padding-top:7px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .moviesApp ul li .right p.last{
    width:70%
  }
  .moviesApp ul li .right p font{
    color:#F8A927;
    font-weight:bold;
    padding-left:5px
  }


  .moviesApp dl{
    width:94%;
    margin:0 auto;
    padding-bottom:10px
  }
  .moviesApp dl dd{
    background:#fff;
    border-radius: 6px;
    margin-bottom:10px;
    padding:10px;
    position:relative;
  }
  .moviesApp dl dd h2{
    font-size:16px;
    font-weight:bold;
  }
  .moviesApp dl dd p{
    color:#666;
    font-size:14px;
    padding-top:10px;
  }
  .moviesApp dl dd p.last{
    font-size:11px;
    color:#f00;
  }
  .moviesApp dl dd p.last font{
    color:#f00;
    font-size:16px;
    font-weight:bold;
    padding-right:1px
  }
  .moviesApp .moreAll{
    text-align:center;
    padding-bottom:15px;
    color:#3F9DEC;
    font-size:15px;
  }
</style>